import _ from 'lodash';
import DataProvider from "../helpers/DataProvider";
import StatePaginationService from "./StatePaginationService";
import StateResponseService from "./StateResponseService";
import StateSettingsService from "./StateSettingsService";
/**
 * State service
 */

export default class StateService {
  /**
   * Store state
   *
   * @private
   * @type {object}
   */

  /**
   * @type {StatePaginationService}
   */

  /**
   * @type {StateSettingsService}
   */

  /**
   * @type {StateResponseService}
   */

  /**
   * State service constructor
   *
   * @param {object} state
   *
   * @return {undefined}
   */
  constructor(state) {
    this.state = {};
    this.pagination = null;
    this.settings = null;
    this.response = null;

    this.getPagination = () => {
      if (!this.pagination) {
        this.pagination = new StatePaginationService(this.state.result && this.state.result.pagination);
      }

      return this.pagination;
    };

    this.getSettings = () => {
      if (!this.settings) {
        this.settings = new StateSettingsService(this.state.result && this.state.result.settings);
      }

      return this.settings;
    };

    this.getResponse = () => {
      if (!this.response) {
        this.response = new StateResponseService(this.state.response);
      }

      return this.response;
    };

    this.isEmptyList = () => {
      return !this.state.result || !this.state.result.list || this.state.result.list.length <= 0;
    };

    this.isFetching = () => {
      return this.state.fetching;
    };

    this.getError = () => {
      return this.state.error;
    };

    this.getList = () => {
      return this.state.result && this.state.result.list && this.state.result.list.length ? this.state.result.list : [];
    };

    this.isEmptyResult = () => {
      return _.isEmpty(this.state.result);
    };

    this.getResultKey = (key, defaultValue = null) => {
      return _.get(this.state.result || {}, key, defaultValue);
    };

    this.mapResult = (callback, key = null) => {
      const obj = key === null ? this.state.result : this.state.result && this.state.result[key];
      const array = obj && obj.length ? obj : Object.entries(obj);
      return array.map(callback);
    };

    this.handlePagination = getModels => {
      const currentPage = this.getPagination().getCurrentPage();
      const maxPage = this.getPagination().getPageCount();

      if (!this.isFetching() && currentPage < maxPage) {
        getModels(this.getPagination().getCurrentPage() + 1, true);
      }
    };

    /**
     * @private
     */
    this.state = !state.result && state.list && {
      result: state
    } || state || {};
  }
  /**
   * Create state service instance
   *
   * @param {object} state
   * @param {boolean} handleResponseList
   *
   * @return {StateService}
   */


}

StateService.create = (state, handleResponseList = false) => {
  if (handleResponseList) {
    return new StateService(DataProvider.handleResponseList(state));
  }

  return new StateService(state);
};